import { useCallback, useEffect, useMemo } from 'react';
import type { FinanceRate } from '@kanda-libs/ks-frontend-services';
import { useFormContext } from '@kanda-libs/ks-component-ts';
import { useCurrentJob } from 'hooks';

import { FINANCE_OPTIONS } from './constants';

export interface CreditLinesHook {
  creditLines: FinanceRate[];
  onClick: (option: FinanceRate) => void;
  isLoading: boolean;
}

function useCreditLines(): CreditLinesHook {
  const { job } = useCurrentJob();
  const { setValue } = useFormContext();

  const onClick = useCallback(
    (rate: FinanceRate) => {
      setValue('financeOption', rate);
    },
    [setValue],
  );

  const financeOptions = useMemo(() => {
    if (!job) return FINANCE_OPTIONS;
    return job?.finance_options || FINANCE_OPTIONS;
  }, [job]);

  useEffect(() => {
    if (!job) return;
    const options = job?.finance_options || FINANCE_OPTIONS;
    setValue('financeOption', options[0]);
  }, [job, setValue]);

  return {
    creditLines: financeOptions,
    isLoading: !job,
    onClick,
  };
}

export default useCreditLines;
